import React from "react";
import useTrackEngagement from "api/BookResource/useTrackEngagement";

const useEngagementClient = (bookId) => {
	const { mutate } = useTrackEngagement(bookId);

	const send = React.useCallback(
		(payload) => {
			mutate(payload);
		},
		[mutate]
	);

	return { send };
};

export default useEngagementClient;
